import React from 'react';
import { NavLink } from 'react-router-dom';
const Filter = props => {
    const {id, title, img, subtitle, category} = props;
    return (
        <div data-uk-filter={category} className="filter-item col-lg-4 col-md-6">
            <div className="card card-shadow card-card card--fourteen rounded-0">
                <figure>
                    <img src={ img } alt="" />                    
                </figure>
                <div className="card-body">
                    <div className="card-contents">
                        <div className="content-top">
                            <span>{ subtitle }</span>
                            <h6><NavLink to={ "/project-details"+id }>{ title }</NavLink></h6>
                        </div>
                    </div>
                </div>
            </div>{/*<!-- Ends: .card -->*/}
        </div>
        
    )
}

export default Filter;